module.exports = __webpack_public_path__ + "img/level_six.21947514.png";